import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useMutation, useQueryClient } from 'react-query';
import { SsoConnectionKeys } from './ssoConnection.keys';

export const deleteSsoConnection = async (id: string) => {
  await clients.admin.delete(`/ssointegrations/${id}`);
};

export function useDeleteSsoConnection(orgId: string) {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteSsoConnection(id), {
    onSuccess: () => {
      queryClient.setQueryData(SsoConnectionKeys.detail(orgId), undefined);
      queryClient.invalidateQueries(SsoConnectionKeys.detail(orgId));
    },
  });
}
